import { makeAutoObservable, runInAction } from 'mobx';
import { IConfiguratorProductApiOptions, IContactUsFeatureDto } from '@canvas-logic/clp-api-types';
import { FetcherApi } from '@canvas-logic/clp-sdk';

export class ContactUsService {
  schema: IContactUsFeatureDto | null = null;

  requestStatus: 'pending' | 'success' | 'error' | 'idle' = 'idle';

  constructor(private readonly params: IConfiguratorProductApiOptions, private readonly fetcher: FetcherApi) {
    makeAutoObservable(
      this,
      {},
      {
        autoBind: true,
      },
    );

    this.getSchema();
  }

  async getSchema() {
    const schema = await this.fetcher.getContactUsFeatureSchema(this.params);

    runInAction(() => {
      this.schema = schema;
    });
  }

  isEnabled(): boolean {
    if (!this.schema?.enabled) {
      return false;
    }

    const configuration = this.schema?.configuration;
    if (!configuration) {
      return false;
    }

    if (configuration.recipients.length === 0) {
      return false;
    }

    if (!configuration.privacyConditionsLink) {
      return false;
    }

    if (!this.hasActiveFields()) {
      return false;
    }

    return true;
  }

  async requestQuote(formData: Record<string, string>) {
    try {
      this.requestStatus = 'pending';
      await this.fetcher.requestQuote(this.params, formData);

      runInAction(() => {
        this.requestStatus = 'success';
      });
    } catch (e) {
      runInAction(() => {
        this.requestStatus = 'error';
      });
    }
  }

  resetStatus() {
    this.requestStatus = 'idle';
  }

  private hasActiveFields(): boolean {
    const configuration = this.schema?.configuration;
    if (!configuration) {
      return false;
    }

    return configuration.fieldGroups.flatMap((group) => group.fields).some((field) => !field.hidden);
  }
}
